import '@/utils/disable-follow-system-theme';
import App from '@mobile/modules/mobile-shop';
import { store } from '@mobile/modules/mobile-shop/model/store';
import generatePage from '@mobile-browser/helpers/generate-page';

generatePage(<App />, {
  store,
});

export default {
  title: '天滙商城',
  langJsonPicker: ['mobile-shop', 'global'],
  template: 'index-limit-max-scale-for-ads',
};
